import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { ReactElement, memo } from 'react';
import { OrderProductError } from '../../../../../../../../../../services/modules/order-product/order-product.types';
import OrderProductImageAndLabelTooltip from '../../../../../../components/OrderProductImageAndLabelTooltip/OrderProductImageAndLabelTooltip';

interface OrderProductGridButtonErrorTooltipProps {
  validationErrors?: OrderProductError[];
  children: ReactElement;
}

const OrderProductGridButtonErrorTooltip = ({
  validationErrors,
  children,
}: OrderProductGridButtonErrorTooltipProps) => {
  if (!validationErrors?.length) {
    return children;
  }

  return (
    <Tooltip TooltipContent={<OrderProductImageAndLabelTooltip productErrors={validationErrors} />}>
      {children}
    </Tooltip>
  );
};

export default memo(OrderProductGridButtonErrorTooltip);
